import eventBanner from '../../misc/acappellaFest.png';
import eventBannerSquare from '../../misc/acappellaFest.png';
import ensemblePhoto from '../../misc/acappellaFestEnsembles.png';


import { useState, useEffect } from 'react';

export default function Festival () {
    // for later <p><span className='underline'>Recommended Charitable Donation</span>: $15 or $20 per person. Receipts available. You can also save time by donating in advance to our <a className='innerLink' href='/summer-fundraiser'>Birdies for Charity</a> summer fundraiser. All givers of $100+ are acknowledged as annual sponsors in our program (time allowing), on our Donations page, and on the VR website. </p>
    const [currentBanner, setCurrentBanner] = useState(eventBanner);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 800) {
                setCurrentBanner(eventBannerSquare);
            } else {
                setCurrentBanner(eventBanner);
            }
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <main>
                <h1 className="h1 text-center w-11/12 m-auto pt-8 pb-12">2026 BOSTON A CAPPELLA FESTIVAL</h1>
                <div className="w-11/12 m-auto mt-0">
                        <div className="pageSection">
                            <div className="event-hero" aria-label="Boston A Cappella Festival event banner">
                                <div className="hero-text">
                                    <h3>Vocal Revolution and VocaMotion present...</h3>
                                    <div className='bg-slate p-10'>
                                        <img 
                                            className='m-auto h-[20%] w-[60%] p-10 bg-white' 
                                            src={currentBanner} 
                                            alt='Event Banner'
                                        />
                                    </div>
                                    <h3>Saturday, September 26, 12–6 PM</h3>
                                </div>
                            </div>

                            <p>
                                *Free to the public and family-friendly!*
                            </p>

                            <p>
                                Our tools of choice for saving the world are our voices and our music.
                                <span className='font-bold text-underline'> We are looking for more ensembles to perform!</span>
                            </p>
                            <br></br>
                            <div className='flex flex-col gap-6'>
                                <div className="callout">
                                    <h4>Your donations make this happen!</h4><br></br>
                                    <p>The success of the Boston A Cappella Festival relies on the generosity
                                    of our audiences and their communities.
                                        This event is supported in part by a gift by
                                        <a className="inner-link"
                                            href="https://www.friendsofherterpark.org/"
                                            target="_blank"
                                            rel="noopener noreferrer"> The Friends of Herter Park</a>,
                                            and your donations.
                                    </p>
                                    <br></br>
                                    <a className='w-[39%]' 
                                        href="https://www.zeffy.com/en-US/donation-form/donate-to-vocal-revolution-vocamotion-and-the-bhs-greater-boston-chapter">
                                        <button style={{width:'39%',fontSize:'medium'}} className ="homePageButton">
                                            Donate Now!
                                        </button>
                                    </a>
                                    <br></br>
                                </div>

                                <div className="pageSubSection">
                                    <h3>Event Details</h3>

                                    <p>
                                        <span className="underline"><strong>Venue</strong></span>:
                                        Herter Park Amphitheatre / Boston
                                    </p>

                                    <p>
                                        <span className="underline"><strong>Date &amp; Time</strong></span>:
                                        Saturday, September 26, 2026, from 12–6pm
                                    </p>

                                    <p>
                                        <span className="underline"><strong>Admission</strong></span>:
                                        Free to the public and family-friendly
                                    </p>

                                    <p>
                                        <span className="underline"><strong>Weather</strong></span>:
                                        The event is subject to cooperative weather.
                                    </p>

                                    <p>
                                        <span className="underline"><strong>Directions</strong></span>:
                                        <a className="inner-link"
                                        href="https://www.google.com/maps/search/?api=1&query=Herter+Park+Amphitheatre+Boston+MA"
                                        target="_blank"
                                        rel="noopener noreferrer"> Get directions to Herter Park Amphitheatre</a>
                                    </p>
                                </div>

                                <div className="pageSubSection">
                                    <h3>About the Festival</h3>

                                    <p>
                                        The Boston A Cappella Festival is a free, public, outdoor arts event
                                        that celebrates the human voice and its ability to produce
                                        high-quality and genuine musical experiences.
                                    </p>

                                    <p>
                                        Each festival's goal is to showcase a breadth and diversity of
                                        singing groups and styles, with community ensembles from high
                                        schoolers to seniors, from Springfield MA to Providence RI to
                                        Boston Metro West.
                                    </p>

                                    <p>
                                        With an anticipated audience of over 500, this event will introduce
                                        individuals to the joys of singing and singing culture, as well as
                                        open doors to numerous ensembles looking for an opportunity to
                                        showcase their skills to an engaged live audience.
                                    </p>

                                    <p>
                                        Genres include barbershop, madrigals, modern, jazz, oldies, and more.
                                    </p>

                                    <img 
                                            className='m-auto h-[35%] w-[90%]' 
                                            src={ensemblePhoto} 
                                            alt='Event Banner'
                                        />
                                </div>

                                <div className="pageSubSection">
                                    <h3>Performing Ensembles</h3>

                                    <div className="ensemble-status">
                                        <strong>2026 participants are still being assembled.</strong><br></br>
                                        We are currently looking for more ensembles to perform
                                        at this year's festival. Check back for updates as the event gets closer.
                                    </div>
                                </div>

                                <div className="pageSubSection">
                                    <h3>Donate Now, Support Our Artists, and Save the World!</h3>

                                    <p>
                                        Every year, 5000 students who sing a cappella in school graduate ...
                                        and never sing in an ensemble again.
                                    </p>

                                    <p>
                                        There is an urgent, ongoing, and expanding need for inclusive voice
                                        ensembles available to singers of all ages. Our festival celebrates
                                        the diversity and generosity of vocal groups who are absolutely part
                                        of the solution. Running an ensemble is hard but deeply valuable
                                        work, and every singer brings positive change to the world through
                                        harmony.
                                    </p>

                                    <p>
                                        You also can be a part of the solution. The success of the Boston
                                        A Cappella Festival relies on the generosity of our audiences and
                                        their communities. You'll have plenty of opportunities at the event
                                        to donate to the festival, buy refreshments, and purchase souvenirs,
                                        but why wait? Donate now with Venmo, credit card, etc. and include
                                        your email, and we'll make sure you get a receipt.
                                    </p>

                                    <p>
                                        All profits received through donations are directed to the ensembles
                                        and their artists.
                                    </p>

                                    <a className='w-[39%]' 
                                    href="https://www.zeffy.com/en-US/donation-form/donate-to-vocal-revolution-vocamotion-and-the-bhs-greater-boston-chapter">
                                        <button style={{width:'39%',fontSize:'medium'}} className ="homePageButton">
                                            Your donations make this happen!
                                        </button>
                                    </a>

                                </div>
                            </div>
                            <br></br>
                    </div>
                </div>
            </main>
        </>
    )
}
